import React from "react";

const FormLayout = ({
  title,
  content,
  actions,
  icon,
  cont,
  pageContent,
  setPageContent,
}) => {
  return (
    <div className="col-span-12 mainFormDiv">
      <div
        className={`py-5 sm:py-6 px-4 sm:px-7 ${
          title !== "" ? "border-b border-solid border-[#D9D9D9]" : ""
        }`}
      >
        <div
          className={`flex ${
            pageContent == "success" ? "justify-center" : "justify-start"
          } gap-3`}
        >
          {icon ? (
            <img
              src={icon}
              className="cursor-pointer w-10 h-10 rounded-full object-cover"
              onClick={() => setPageContent && setPageContent(cont)}
              alt="profile"
            />
          ) : null}
          <p
            className={`text-[16px] sm:text-[18px] md:text-[20px] font-[600] text-[#303030] font-poppins text-left`}
          >
            {title}
          </p>
        </div>
      </div>

      {/* Form */}

      <div className="px-4 sm:px-7 w-[100%]">{content}</div>
      {actions && (
        <div className="px-4 sm:px-7 py-5 sm:py-6 w-[100%] flex justify-end items-center gap-3 edit-profile-actions">
          {actions}
        </div>
      )}
    </div>
  );
};

export default FormLayout;
